<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="500"
            min="0"
            :error="errors.bodyWeight.length > 0"
            :error-messages="errors.bodyWeight"
            v-model="form.bodyWeight"
            :placeholder="$t('dashboard_new_evollu.measurement_types.body_weight_short')+' (Kg)'"
            :label="$t('dashboard_new_evollu.measurement_types.body_weight_short')+' (Kg)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.bodyMassIndex.length > 0"
          :error-messages="errors.bodyMassIndex"
          v-model="form.bodyMassIndex"
          :placeholder="$t('dashboard_new_evollu.measurement_types.body_mass_index_short')"
          :label="$t('dashboard_new_evollu.measurement_types.body_mass_index_short')"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.bodyWaterPercentage.length > 0"
          :error-messages="errors.bodyWaterPercentage"
          v-model="form.bodyWaterPercentage"
          :placeholder="$t('dashboard_new_evollu.measurement_types.body_water_percentage_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.body_water_percentage_short')+' (%)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.bodyFatPercentage.length > 0"
          :error-messages="errors.bodyFatPercentage"
          v-model="form.bodyFatPercentage"
          :placeholder="$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short')+' (%)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="100"
          min="0"
          :error="errors.bodyMuscleMass.length > 0"
          :error-messages="errors.bodyMuscleMass"
          v-model="form.bodyMuscleMass"
          :placeholder="$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short')+' (%)'"
          :label="$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short')+' (%)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const BODY_WEIGHT_TYPE_ID = 1
const BODY_MASS_INDEX_TYPE_ID = 8
const BODY_WATER_PERCENTAGE = 7
const BODY_FAT_PERCENTAGE = 6
const BODY_MUSCLE_MASS = 53

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        bodyWeight: null,
        bodyMassIndex: null,
        bodyWaterPercentage: null,
        bodyFatPercentage: null,
        bodyMuscleMass: null
      },
      errors: {
        bodyWeight: [],
        bodyMassIndex: [],
        bodyWaterPercentage: [],
        bodyFatPercentage: [],
        bodyMuscleMass: []
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 5
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.bodyWeight !== null && this.form.bodyWeight !== '') &&
        (this.form.bodyMassIndex !== null && this.form.bodyMassIndex !== '') &&
        (this.form.bodyWaterPercentage !== null && this.form.bodyWaterPercentage !== '') &&
        (this.form.bodyFatPercentage !== null && this.form.bodyFatPercentage !== '') &&
        (this.form.bodyMuscleMass !== null && this.form.bodyMuscleMass !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.bodyWeight": function(value) {
        if(value !== '' && (value < 1 || value > 500)) {
          this.errors.bodyWeight = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
        }
        else {
          this.errors.bodyWeight = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === BODY_WEIGHT_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_WEIGHT_TYPE_ID)
          elem.value = this.errors.bodyWeight.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.bodyWeight.length === 0 ? value : null,
            typeId: BODY_WEIGHT_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.bodyMassIndex": function(value) {
      if(value !== '' && (value < 1 || value > 100)) {
        this.errors.bodyMassIndex = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 100})]
      }
      else {
        this.errors.bodyMassIndex = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BODY_MASS_INDEX_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_MASS_INDEX_TYPE_ID)
        elem.value = this.errors.bodyMassIndex.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bodyMassIndex.length === 0 ? value : null,
          typeId: BODY_MASS_INDEX_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.bodyWaterPercentage": function(value) {
      if(value !== '' && (value < 1 || value > 100)) {
        this.errors.bodyWaterPercentage = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 100})]
      }
      else {
        this.errors.bodyWaterPercentage = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BODY_WATER_PERCENTAGE)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_WATER_PERCENTAGE)
        elem.value = this.errors.bodyWaterPercentage.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bodyWaterPercentage.length === 0 ? value : null,
          typeId: BODY_WATER_PERCENTAGE
        })
      }
      this.checkCanSubmit()
    },
    "form.bodyMuscleMass": function(value) {
      if(value !== '' && (value < 1 || value > 100)) {
        this.errors.bodyMuscleMass = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 100})]
      }
      else {
        this.errors.bodyMuscleMass = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BODY_MUSCLE_MASS)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_MUSCLE_MASS)
        elem.value = this.errors.bodyMuscleMass.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bodyMuscleMass.length === 0 ? value : null,
          typeId: BODY_MUSCLE_MASS
        })
      }
      this.checkCanSubmit()
    },
    "form.bodyFatPercentage": function(value) {
      if(value !== '' && (value < 1 || value > 100)) {
        this.errors.bodyFatPercentage = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 100})]
      }
      else {
        this.errors.bodyFatPercentage = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BODY_FAT_PERCENTAGE)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BODY_FAT_PERCENTAGE)
        elem.value = this.errors.bodyFatPercentage.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bodyFatPercentage.length === 0 ? value : null,
          typeId: BODY_FAT_PERCENTAGE
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
